
import React, { useState, useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import service from '../service';
import common from '../../../common/common';

const ExternalQuestionDialog = (props) => {
    const { currentExternalQuestion, closeDialog, uid, classroomId, roleId, nickName } = props;
    useEffect(() => {
        const onMessage = (event) => {
            if (event.data.type=== 'close') {
                closeDialog()
            }
        } 
        window.addEventListener('message', onMessage, false);
        return () => {
            window.removeEventListener('message', onMessage)
        }
    }, [closeDialog])
    const reload = () => {
        try {
            document.getElementById('externalQuestion').contentWindow.location.reload();
        } catch (e) {
            document.getElementById('externalQuestion').src = document.getElementById('externalQuestion').src;
            // console.warn(e);
        }
    }
    const handleUrl = (url) => {
        if (url) {
            const userName = encodeURIComponent(nickName);
            if (url.indexOf('?') > -1) {
                return url + `&usedScenario=playback&uid=${uid}&cid=${classroomId}&token=${common.getSearchParam()?.token}&questionId=${currentExternalQuestion.questionId}&roleId=${roleId}&nickName=${userName}`
            } else {
                return url + `?usedScenario=playback&uid=${uid}&cid=${classroomId}&token=${common.getSearchParam()?.token}&questionId=${currentExternalQuestion.questionId}&roleId=${roleId}nickName=${userName}`
            }
        }
    }
    const IFrameStyles = useMemo(() => {
        if (!common.isMobile()) {
            return {
                width: '928px',
                height: '522px'
            }
        } else {
            return {
                width: document.body.clientWidth + 'px',
                height: (document.body.clientWidth * 9 / 16) + 'px'
            }
        }
    }, []);
    return (
        <div className={classNames(styles.externalQuestionDialog, {
            [styles.show]: !!currentExternalQuestion
        })}>
            <div className={styles.Icons}>
                <span className={styles.refresh} onClick={reload}></span>
                <span className={styles.close} onClick={closeDialog}></span>
            </div>
            {currentExternalQuestion?.studyUrl && <iframe id='externalQuestion'  style={IFrameStyles} className={styles.iFrame} src={handleUrl(currentExternalQuestion?.studyUrl)} frameborder="0"></iframe>}
        </div>
    )
}
export  default ExternalQuestionDialog;
